import { render } from "./ticket.vue?vue&type=template&id=1554ebd4"
import script from "./ticket.vue?vue&type=script&lang=ts"
export * from "./ticket.vue?vue&type=script&lang=ts"

import "./ticket.vue?vue&type=style&index=0&id=1554ebd4&lang=css"
script.render = render

export default script